export default __webpack_public_path__ + "static/media/placeholder-image-02.adbd0e93.jpg";